// src/utils/axiosinstance.js
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import dayjs from "dayjs";
import { refreshTokensThunk } from "../redux/features/Auth/authThunk";
import { updateTokens } from "../redux/features/Auth/authSlice";

const baseURL =
  process.env.NODE_ENV === "production"
    ? "https://api.erissgallery.ir"
    : "http://127.0.0.1:8000";

console.log("🌐 API Base URL:", baseURL);

export const backend = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const authAxiosInstance = (userInfo, dispatch) => {
  const instance = axios.create({
    baseURL,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${userInfo?.access}`,
    },
  });

  instance.interceptors.request.use(
    async (req) => {
      if (!userInfo?.access) return req;

      const accessToken = jwtDecode(userInfo.access);
      const accessIsExpired = dayjs.unix(accessToken.exp).diff(dayjs()) < 60000;

      if (!accessIsExpired) return req;

      // رفرش توکن
      const refreshToken = jwtDecode(userInfo.refresh);
      const refreshIsExpired = dayjs.unix(refreshToken.exp).diff(dayjs()) < 60000;

      if (!refreshIsExpired) {
        try {
          const response = await dispatch(refreshTokensThunk(userInfo.refresh)).unwrap();
          dispatch(updateTokens({ access: response.access, refresh: response.refresh }));
          req.headers.Authorization = `Bearer ${response.access}`;
          return req;
        } catch (error) {
          // رفرش ناموفق
          localStorage.removeItem("userInfo");
          window.location.href = "/phone";
          return Promise.reject(new Error("Please sign in again!"));
        }
      } else {
        // توکن رفرش منقضی شده
        localStorage.removeItem("userInfo");
        window.location.href = "/phone";
        return Promise.reject(new Error("Please sign in again!"));
      }
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  return instance;
};